module.exports = __webpack_public_path__ + "static/media/layout-steps.987481ad.PNG";